import { AspectRatio, Card, CardContent, CardOverflow, Link, Stack, Typography } from "@mui/joy";
import React from "react";
import './VenueDisplay.css'
import { AirportShuttle, CarRental } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";

function WeddingPartyDisplay() {
    const isMobile = useMediaQuery('(max-width:600px)');

    let iframe_url = "https://www.google.com/maps/embed/v1/place?q=place_id:ChIJx2e02lm1OYgRX2iqFApdTgs&key=" +
        process.env.REACT_APP_GOOGLE_MAP_API_KEY;

    return (
        <div className="venue-card">
            <Card>
                <Typography level="h1">
                    The Venue
                </Typography>
                <CardOverflow>
                    <AspectRatio ratio="2">
                        <img
                            src="https://www.wildflowerwoodsweddings.com/uploads/1/4/2/5/142596733/img-3039_orig.jpg"
                            loading="lazy"
                            alt=""
                            onClick={() => window.open("https://www.wildflowerwoodsweddings.com/")}
                            style={{ cursor: 'pointer' }}
                        />
                    </AspectRatio>
                </CardOverflow>
                <CardContent>
                    <Typography level="h2">
                        The Wildflower Woods
                    </Typography>
                    <Typography level="h4">
                        <Link href="https://maps.app.goo.gl/EYFhqSC9aDyp99PL9">Directions to the venue</Link>
                    </Typography>
                    <Stack direction={isMobile ? "column" : "row"}>
                        <div className="embedded-maps">
                            <iframe
                                width="250"
                                height="250"
                                title="Venue Location"
                                loading="lazy"
                                src={iframe_url}>
                            </iframe>
                        </div>
                        <Card>
                            <Typography level="h4">Transportation Services</Typography>
                            <Typography level="body-sm">
                                A complimentary shuttle service will be provided to the local
                                hotel for your convenience.
                            </Typography>
                            <Stack flexDirection="row">
                                <AirportShuttle />
                                <Typography level="body-lg">
                                    Shuttle to and from local Hotels will be provided
                                </Typography>
                            </Stack>
                            <Stack spacing={2}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <CarRental />
                                    <Typography level="body-lg">
                                        Rental cars are also available at the local airport.
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Typography level="h4" sx={{ marginTop: 2 }}>
                                Shuttle Timetable
                            </Typography>
                            <table className="shuttle-timetable">
                                <thead>
                                    <tr>
                                        <th>Pickup Location</th>
                                        <th>Pickup Times</th>
                                        <th>Return Times</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    <tr>
                                        <td>Mt Vernon Grand Hotel</td>
                                        <td>12:25 PM, 1:40 PM</td>
                                        <td>8:20 PM, 9:40 PM</td>
                                    </tr>
                                    <tr>
                                        <td>Comfort Inn Mt Vernon Downtown</td>
                                        <td>12:45 PM, 2:00 PM</td>
                                        <td>8:20 PM, 9:40 PM</td>
                                    </tr>

                                </tbody>
                            </table>
                        </Card>
                    </Stack>
                </CardContent>
            </Card>
        </div>
    );
}

export default WeddingPartyDisplay